// extracted by mini-css-extract-plugin
module.exports = {"container":"sa-z","categoryItem":"ta-z","active":"ua-z"};